<template>
    <div>
        <div v-if="!task.completed" class="flex items-center space-x-3 text-gray-500">
            <i class="text-lg fa-regular fa-square"></i>
            <a :href="task.link" class="mf-link">{{ translatedTitle }}</a>
        </div>

        <div v-if="task.completed" class="flex items-center space-x-3 text-gray-700">
            <i class="text-lg text-green-700 fa-solid fa-square-check"></i>
            <a :href="task.link" class="font-medium mf-link">{{ translatedTitle }}</a>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        task: {
            type: Object,
            required: true,
        },
    });

    const translatedTitle = computed(() => {
        if (!props.task || !props.task.title) {
            return '';
        }

        return _mft(`dashboard:${props.task.title}`);
    });
</script>

<style scoped>

</style>
